import IconHeart from '../../../Icon/Heart';
import IconHeartSolid from '../../../Icon/Heart/Solid';
import ProcessingIndicator from '../../../ProcessingIndicator';
import computeClassName from "../../../../../utils/computeClassName";
import handleClick from "../../../../../utils/handleClick";

const constants = Object.freeze({

  CLASSNAME_BASE: 'inline-flex flex-row items-center',
  CLASSNAME_IS_SAVING_IN_PROGRESS: {
    true: {
      CLASSNAME_IS_ACTION_DISABLED: {
        true: '',
        false: ''
      }
    },
    false: {
      CLASSNAME_IS_ACTION_DISABLED: {
        true: 'opacity-30 cursor-auto',
        false: 'justify-center cursor-pointer'
      }
    }
  },
  CLASSNAME_IS_SAVED: {
    true: 'text-cc-alert',
    false: 'text-cc-muted-contrast'
  },
  COMPONENT_IS_SAVED: {
    true: IconHeartSolid,
    false: IconHeart
  }
});

const propsDefaults = Object.freeze({
  isSaved: false,
  isActionDisabled: false,
  saveActionTitle: 'Save partner',
  saveActionFn: null,
  saveActionFnArgs: null,
  removeActionTitle: 'Remove partner',
  removeActionFn: null,
  removeActionFnArgs: null,
  isSavingInProgress: false,
  savingInProgressText: 'Partner saving is in progress...'
});

function takeAction(isSaved, saveActionFn, saveActionArgs, removeActionFn, removeActionArgs) {
  return isSaved ?
    handleClick(removeActionFn, removeActionArgs):
    handleClick(saveActionFn, saveActionArgs);
}

export default function PartnerSavedStatus({
  isSaved = propsDefaults.isSaved,
  isActionDisabled = propsDefaults.isActionDisabled,
  saveActionTitle = propsDefaults.saveActionTitle,
  saveActionFn = propsDefaults.saveActionFn,
  saveActionFnArgs = propsDefaults.saveActionFnArgs,
  removeActionTitle = propsDefaults.removeActionTitle,
  removeActionFn = propsDefaults.removeActionFn,
  removeActionFnArgs = propsDefaults.removeActionFnArgs,
  isSavingInProgress = propsDefaults.isSavingInProgress,
  savingInProgressText = propsDefaults.savingInProgressText,
  className = ''
}) {
  const computedClassName = computeClassName(className, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_SAVING_IN_PROGRESS[isSavingInProgress].CLASSNAME_IS_ACTION_DISABLED[isActionDisabled]} ${constants.CLASSNAME_IS_SAVED[isSaved]}`);
  const IsSavedIconComponent = constants.COMPONENT_IS_SAVED[isSaved];
  const computedIsSavedComponentTitle = isSaved ? removeActionTitle : saveActionTitle;
  const computedActionClickFn = takeAction(isSaved, saveActionFn, saveActionFnArgs, removeActionFn, removeActionFnArgs);
  return (
    isSavingInProgress ?
      <span className={computedClassName}>
        <ProcessingIndicator size="medium" title={savingInProgressText}/>
      </span> :
      isActionDisabled ?
        <span className={computedClassName}>
          <IsSavedIconComponent aria-hidden="true" className="!inline"/>
        </span> :
        <button type="button"
                className={computedClassName}
                onClick={computedActionClickFn}
                title={computedIsSavedComponentTitle}>
          <span className="sr-only">{computedIsSavedComponentTitle}</span>
          <IsSavedIconComponent aria-hidden="true" className="!inline"/>
        </button>
  );

}
